import React, { useState } from 'react';
import { Outlet, NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  FiHome,
  FiTrendingUp,
  FiTrendingDown,
  FiPercent,
  FiMenu,
} from 'react-icons/fi';
import Sidebar from './Sidebar';

const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user } = useAuth();
  const location = useLocation();

  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  const getPageTitle = () => {
    const titles = {
      '/': user?.first_name ? `שלום, ${user.first_name}` : 'דשבורד',
      '/incomes': 'הכנסות',
      '/expenses': 'הוצאות',
      '/maaser': 'מעשר',
      '/settings': 'הגדרות',
      '/admin': 'ניהול',
    };
    return titles[location.pathname] || 'מחשבון מעשר';
  };

  const userInitial = user?.first_name ? user.first_name.charAt(0) : '?';

  return (
    <div className="app-layout">
      {/* Desktop sidebar */}
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

      {/* Mobile sidebar overlay */}
      {sidebarOpen && (
        <div className="sidebar-overlay" onClick={toggleSidebar} />
      )}

      {/* Main content */}
      <div className="main-content">
        {/* Mobile top bar */}
        <header className="mobile-topbar">
          <button className="mobile-topbar-btn" onClick={toggleSidebar} aria-label="תפריט">
            <FiMenu />
          </button>
          <h1 className="mobile-topbar-title">{getPageTitle()}</h1>
          <NavLink to="/settings" className="mobile-topbar-avatar" aria-label="הגדרות">
            {userInitial}
          </NavLink>
        </header>

        <Outlet />
      </div>

      {/* Mobile bottom navigation */}
      <nav className="bottom-nav" aria-label="ניווט ראשי">
        <NavLink to="/" end className={({ isActive }) => `bottom-nav-item ${isActive ? 'active' : ''}`}>
          <FiHome />
          <span>דשבורד</span>
        </NavLink>
        <NavLink to="/incomes" className={({ isActive }) => `bottom-nav-item ${isActive ? 'active' : ''}`}>
          <FiTrendingUp />
          <span>הכנסות</span>
        </NavLink>
        <NavLink to="/expenses" className={({ isActive }) => `bottom-nav-item ${isActive ? 'active' : ''}`}>
          <FiTrendingDown />
          <span>הוצאות</span>
        </NavLink>
        <NavLink to="/maaser" className={({ isActive }) => `bottom-nav-item ${isActive ? 'active' : ''}`}>
          <FiPercent />
          <span>מעשר</span>
        </NavLink>
      </nav>
    </div>
  );
};

export default Layout;
